import "../scss/app.scss";
import { popper } from '@popperjs/core';
import { ScrollSpy, Tooltip, Dropdown, Popover, Collapse, Tab, Modal } from "bootstrap";
import Flickity from "flickity";
import AOS from "aos";
import GLightbox from "glightbox";

/* include navigation setup */
import "./inc/navigation.js";

document.addEventListener("DOMContentLoaded", function () {
  var scrollHandler = function () {
    if (window.scrollY === 0) {
      document.body.classList.add("is-scroll-top");
    } else {
      document.body.classList.remove("is-scroll-top");
    }
    if (window.scrollY > 500) {
      document.body.classList.add("far-away");
    } else {
      document.body.classList.remove("far-away");
    }
    document.body.style.setProperty("--scroll-top", Math.round(window.scrollY * 100 / document.documentElement.getBoundingClientRect().height) / 100);
  };
  window.addEventListener("scroll", scrollHandler);
  window.dispatchEvent(new Event("scroll"));

  /* MENU */

  document
    .getElementById("menu_btn")
    .addEventListener("click", function (event) {
      document.body.classList.toggle("menu_active");
    });
  document
    .getElementById("close_menu_btn")
    .addEventListener("click", function (event) {
      document.body.classList.toggle("menu_active");
    });

  var menu_links = document.querySelectorAll(
    ".main-menu > ul > li.menu-item-has-children > a"
  );

  for (const menu_item of menu_links) {
    menu_item.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      menu_item.parentNode.classList.toggle("selected");
      let is_active = false;
      for (const main_item of menu_links) {
        if (menu_item != main_item) {
          main_item.parentNode.classList.remove("selected");
        }
        if (main_item.parentNode.classList.contains("selected")) {
          is_active = true;
        }
      }
      if (is_active) {
        document.querySelector("body").classList.add("menu_active");
      } else {
        document.querySelector("body").classList.remove("menu_active");
      }

      return false;
    });
  }


  document.querySelector(".menu_modal").addEventListener("click", function () {
    for (const menu_item of menu_links) {
      menu_item.parentNode.classList.remove("selected");
    }
    document.querySelector("body").classList.remove("menu_active");
  });

  var filter_selector = document.querySelector(".filter_header select");
  if (filter_selector) {
    filter_selector.addEventListener("change", function () {
      document.location = filter_selector.value;
    });
  }

  /* FIN MENU */

  var iframes = document.querySelectorAll(".video-section iframe");
  for (const iframe of iframes) {
    console.log("ts0");
    iframe.parentNode.classList.add("ratio");
    iframe.parentNode.classList.add("ratio-16x9");
  }

  var galleryElems = document.querySelectorAll(".partner-slider");
  for (var i = 0, len = galleryElems.length; i < len; i++) {
    var galleryElem = galleryElems[i];
    new Flickity(galleryElem, {
      cellAlign: "center",
      contain: true,
      autoPlay: false,
      pageDots: false,
      groupCells: false,
    });
  }

  var galleryElems = document.querySelectorAll(
    ".articles_section .slider_container"
  );
  for (var i = 0, len = galleryElems.length; i < len; i++) {
    var galleryElem = galleryElems[i];
    new Flickity(galleryElem, {
      cellAlign: "center",
      contain: true,
      autoPlay: false,
      pageDots: false,
      groupCells: true,
    });
  }

  var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
  var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
    return new Tooltip(tooltipTriggerEl)
  });

  const collapseElementList = document.querySelectorAll('.collapse')
  const collapseList = [...collapseElementList].map(collapseEl => new Collapse(collapseEl, { toggle: false }))

  AOS.init({
    duration: 1000,
    easing: "ease",
    once: true,
    offset: 120,
  });

  const lightbox = GLightbox({
    touchNavigation: true,
    loop: true,
    autoplayVideos: true,
  });
  const lightbox_content = GLightbox({
    selector: '.gallery-item a',
    touchNavigation: true,
    loop: true,
    autoplayVideos: true,
  });

});

window.addEventListener(
  "resize",
  function (event) {
    // do functions here when resize
  },
  true
);

var menu_links = document.querySelectorAll(
  "#primary-menu > li.menu-item-has-children > a"
);

for (const menu_item of menu_links) {
  menu_item.addEventListener("click", (e) => {
    console.log(e);
    menu_item.parentNode.classList.toggle("selected");
    let is_active = false;
    for (const main_item of menu_links) {
      if (menu_item != main_item) {
        main_item.parentNode.classList.remove("selected");
      }
      if (main_item.parentNode.classList.contains("selected")) {
        is_active = true;
      }
    }
    if (is_active) {
      document.querySelector("body").classList.add("menu_active");
    } else {
      if (
        !document
          .getElementById("site-navigation")
          .classList.contains("toggled")
      ) {
        document.querySelector("body").classList.remove("menu_active");
      }
    }
    e.preventDefault();
    e.stopPropagation();
    return false;
  });
}

if (document.querySelector("#chapters:not(.static)")) {
  var scrollSpy = new ScrollSpy(document.body, {
    target: "#chapters",
    offset: 180,
  });
}

var chapter_selector = document.querySelector("#chapter_selector select");
if (chapter_selector) {
  chapter_selector.addEventListener("change", function () {
    var url = location.href;
    location.href = chapter_selector.value;
    history.replaceState(null, null, url);
  });
}

var triggerEvent = function (elem, event) {
  var evt = new MouseEvent(event, {
    bubbles: true,
    cancelable: true,
    view: window,
  });
  var canceled = !elem.dispatchEvent(evt);
};

var search_btn = document.querySelector("a.search_btn");
if (search_btn) {
  search_btn.addEventListener("click", function () {
    var modal = document.querySelector(".modal_search");
    document.getElementById("search_input").focus();
    modal.classList.toggle("active");
  });
  document
    .querySelector(".modal_search .modal")
    .addEventListener("click", function () {
      var modal = document.querySelector(".modal_search");
      modal.classList.toggle("active");
    });
  document
    .querySelector(".modal_search .close_btn")
    .addEventListener("click", function () {
      var modal = document.querySelector(".modal_search");
      modal.classList.toggle("active");
    });
}
